import { useSearchContext } from "@pineseed/gui/provider/search";

/**
 * Search hook — delegates to SearchProvider context.
 * All search state and handler integration are managed by SearchProvider.
 */
export function useSearch() {
  return useSearchContext();
}
